module.exports = __webpack_public_path__ + "static/media/pkc_background.6988b341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/pkc_background.png
// module id = 2619
// module chunks = 0